import { CourseCenter, Course } from '@/networks/api'
import { CourseLocation, siftParams } from '@/defines'
// import judgeTokenExp from '@/util/judgeTokenExp'

// import globalTypes from '@/store/types'
import types from './types'

function sortOtherSiftFn (obj, ary) {
  const newObj = {}
  ary.forEach(name => {
    if (obj[name]){
      newObj[name] = obj[name]
    }
  });
  return newObj
}

export default {
  state() {
    return {
      courseSift: null,
      courseList: null,
      pagination: null,
      // difficultGuide: null,
      purchaseCount: null,
      courseCount: null,
      difficultDegree: null,
      showDegreeTip: false,
      showDiffcultRecommend: false,
      showDifficultDegree: false,
      showDifficultGuide: true,
      isAlreadyDegree: '',
      // hasLiteracyWwwSift: null,
      routerLock: false,
      siftCourseType: null,
      siftCourseTypes: null,
      siftNames: null,
      siftOthers: null,
      siftBread: [],
      siftSubjects: null,
      siftSubject: null,
      siftGrade: null,
      siftGrades: null
    }
  },
  mutations: {
    [types.SET_SIFT_GRADES](state, payload) {
      state.siftGrades = payload
    },
    [types.SET_SIFT_GRADE](state, payload) {
      state.siftGrade = payload
    },
    [types.SET_SIFT_SUBJECTS](state, payload) {
      state.siftSubjects = payload
    },
    [types.SET_SIFT_SUBJECT](state, payload) {
      state.siftSubject = payload
    },
    [types.SET_SIFT_BREAD](state, payload) {
      state.siftBread = payload
    },
    [types.SET_COURSE_SIFT](state, payload) {
      state.courseSift = payload
    },
    [types.SET_SIFT_COURSETYPES](state, payload) {
      state.siftCourseTypes = payload
    },
    [types.SET_SIFT_COURSETYPE](state, payload) {
      state.siftCourseType = payload
    },
    [types.SET_SIFT_NAMES](state, payload) {
      state.siftNames = payload
    },
    [types.SET_SIFT_OTHERS](state, payload) {
      // 如果筛选项中有学科则不显示属性
      // if ('subjects' in payload) {
      //   const obj = Object.create(null)
      //   obj['subjects'] = payload['subjects']
      //   state.siftOthers = obj
      // } else {
      //   state.siftOthers = payload
      // }
      // 如果筛选项中有类别则不显示其他
      if ('courseTypes' in payload) {
        const obj = Object.create(null)
        obj['courseTypes'] = payload['courseTypes']
        state.siftOthers = obj
      } else {
        state.siftOthers = payload
      }
      // state.siftOthers = payload
    },
    [types.SET_ROUTERLOCK](state, payload) {
      state.routerLock = payload
    },
    [types.SET_SHOWDIFFICULTGUIDE](state, payload) {
      state.showDifficultGuide = payload
    },
    [types.SET_ISALREADYDEGREE](state, payload) {
      state.isAlreadyDegree = payload
    },
    [types.SET_SHOWDEGREETIP](state, payload) {
      state.showDegreeTip = payload
    },
    [types.SET_SHOWDIFFICULTDEGREE](state, payload) {
      state.showDifficultDegree = payload
    },
    [types.SET_SHOWDIFFCULTRECOMMEND](state, payload) {
      state.showDiffcultRecommend = payload
    },
    [types.SET_COURSE_LIST](state, payload) {
      state.courseList = payload
    },
    [types.SET_PAGENATION](state, payload) {
      state.pagination = payload
    },
    [types.ADD_COURSE_LIST](state, payload) {
      state.courseList = state.courseList.concat(payload)
    },
    [types.SET_PURCHASE_COUNT](state, payload) {
      state.purchaseCount = payload
    },
    [types.SET_COURSE_COUNT](state, payload) {
      state.courseCount = payload
    },
    // [types.SET_DIFFICULT_GUIDE] (state, payload) {
    //   state.difficultGuide = payload
    // },
    [types.SET_DIFFICULT_DEGREE](state, payload) {
      state.difficultDegree = payload
    },
    [types.UPDATA_COURSE_LIST](state, payload) {
      for (let key in payload) {
        const index = state.courseList.findIndex(item => Number(item.id) === Number(key))
        if (index !== -1) {
          if ('resale' in payload[key]) {
            state.courseList[index].price.resale = payload[key].resale
          }
          if ('classLimitNum' in payload[key]) {
            state.courseList[index].class.leftNum = payload[key].classLimitNum
          }
        }
      }
    }
  },
  actions: {
    async [types.GET_COURSE_SIFT]({ commit, rootState, state }, { route }) {
      try {
        const { params, query } = route
        const { grade, courseType, subject = 0 } = params
        const location = CourseLocation[courseType] || 5
        const provinceId = rootState.xAreaID || 100
        const newQuery = {}
        for (let key in query) {
          if (query[key] && siftParams[key]) {
            newQuery[siftParams[key]] = query[key]
          }
        }
        const { switch_grade, switch_subject } = query
        const { data } = await CourseCenter.getCourseSift(
          { location, provinceId, grade, courseType },
          {
            rootState,
            params: { ...newQuery, subjectId: subject, switch_grade, switch_subject }
          }
        )
        // 过滤筛选项
        commit(types.SET_SIFT_SUBJECTS, null)
        commit(types.SET_SIFT_SUBJECT, null)
        commit(types.SET_SIFT_GRADES, null)
        commit(types.SET_SIFT_GRADE, null)
        commit(types.SET_SIFT_COURSETYPES, null)
        commit(types.SET_SIFT_COURSETYPE, null)
        // const { grades, courseTypes, names, ...otherSift } = data
        const { names, ...otherSift } = data
        const newObj = Object.create(null)
        for (let key in otherSift) {
          const arr = otherSift[key]
          if (arr && arr.length > 0) {
            const hitItem = arr.filter(item => item && item.selected)
            if (hitItem.length > 0) {
              switch (key) {
                case 'subjects':
                  commit(types.SET_SIFT_SUBJECTS, otherSift[key])
                  commit(types.SET_SIFT_SUBJECT, hitItem[0])
                  break
                case 'grades':
                  commit(types.SET_SIFT_GRADES, otherSift[key])
                  commit(types.SET_SIFT_GRADE, hitItem[0])
                  break
                case 'courseTypes':
                  commit(types.SET_SIFT_COURSETYPES, otherSift[key])
                  commit(types.SET_SIFT_COURSETYPE, hitItem[0])
                  break
                default:
                  newObj[key] = hitItem[0]
              }
              delete otherSift[key] // 删选隐藏项
            }
          }
        }

        commit(types.SET_SIFT_NAMES, names)

        const selectedSifts = sortOtherSiftFn(newObj, data.namesMapping)
        commit(types.SET_SIFT_BREAD, selectedSifts)

        const sortOtherSifts = sortOtherSiftFn(otherSift, data.namesMapping)
        commit(types.SET_SIFT_OTHERS, sortOtherSifts)
        
        commit(types.SET_COURSE_SIFT, data)
      } catch (e) {
        console.log('APIERROR===GET_COURSE_SIFT===', e)
        commit(types.SET_COURSE_SIFT, null)
      }
    },
    async [types.GET_COURSE_LIST]({ dispatch, commit, rootState, state }, { route }) {
      try {
        const { params, query } = route
        const { courseType, grade, subject } = params
        const page = 1
        // 课程标准化-选课中心课程列表
        const provinceId = rootState.xAreaID || 100
        const location = CourseLocation[courseType] || 5
        const newQuery = {}
        for (let key in query) {
          if (query[key] && siftParams[key]) {
            newQuery[siftParams[key]] = query[key]
          }
        }
        const { switch_grade, switch_subject } = query
        const { data, headers } = await Course.getCourses(
          { provinceId, courseType, location, grade },
          {
            rootState,
            params: {
              curpage: page,
              ...newQuery,
              subjectId: subject,
              switch_grade,
              switch_subject
            }
          }
        )
        commit(types.SET_COURSE_LIST, data || [])
        commit(types.SET_PAGENATION, Number(headers['x-pagenation-count']))
        commit(types.SET_PURCHASE_COUNT, Number(headers['x-purchase-count'] || 0))
        commit(types.SET_COURSE_COUNT, Number(headers['x-course-count'] || 0))
      } catch (e) {
        commit(types.SET_COURSE_LIST, [])
        commit(types.SET_PURCHASE_COUNT, 0)
        commit(types.SET_COURSE_COUNT, 0)
        const response = e.response
        const status = response && response.status
        if (status === 404) return
        console.log('APIERROR===GET_COURSE_LIST===', e)
      }
    },
    // async [types.GET_DIFFICULT_GUIDE] ({ commit, rootState, state }, {route}) {
    //   try {
    //     const { subject, grade } = route.params
    //     const { termId, switch_grade, switch_subject } = route.query
    //     // 选课中心页 带上from=1
    //     const { data } = await CourseCenter.difficultGuide({subject, grade}, {rootState, params: {termId, switch_grade, switch_subject, from: 1}})
    //     commit(types.SET_DIFFICULT_GUIDE, data.data)
    //   } catch (e) {
    //     const response = e.response
    //     const status = response && response.status
    //     if (status === 404) return
    //     console.log('APIERROR==GET_DIFFICULT_GUIDE==', e)
    //   }
    // },
    async [types.GET_DIFFICULT_DEGREE]({ commit, rootState, state }, data) {
      const { route, answers, recommendId } = data
      try {
        const optionIds = answers
        const source = 1
        const { grade } = route.params
        const { data:_data } = await CourseCenter.getDifficultDegree(
          { option_ids: optionIds, grade_id: grade, grading_id: recommendId },
          { rootState, params: { optionIds, source } }
        )
        commit(types.SET_DIFFICULT_DEGREE, _data.data)
      } catch (e) {
        const response = e.response
        const status = response && response.status
        if (status === 404) return
        console.log('APIERROR====SET_DIFFICULT_DEGREE error====', e)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/CourseCenter/store/index.js